import React from 'react';
import { TPEReactTable } from 'src/components/shared/TPEReactTable';
import { JournalLine } from 'src/models/calculation-builder/Journal';
import CONSTANTS from 'src/utils/constants';
import { CalculationBuilderContext } from '../CalculationBuilderView';
import { CalculationSourceType } from 'src/models/common/CalculationSource';
import {shouldSkipField} from "src/components/calculation-builder/configure-journals/Utils";

export default function JournalEntriesGrid(props: {data: JournalLine[], journalsLinesLoading: boolean}) {
    const { calcBuilderState } = React.useContext(CalculationBuilderContext);
    const { calculationSource } = calcBuilderState;
    const { data, journalsLinesLoading } = props;
    
    const getColumnDefinitions = () => {
        const hasJeTagData = data.some(line =>
            line[CONSTANTS.JE_FIELDS.JE_TAG_ID.ACCESSOR as keyof JournalLine] ||
            line[CONSTANTS.JE_FIELDS.JE_TAG_DESCRIPTION.ACCESSOR as keyof JournalLine]
        );
        
        const colDefs: any[] = [];
            Object.values(CONSTANTS.JE_FIELDS).forEach(field => {
                if (!shouldSkipField(field, calculationSource, hasJeTagData)) {
                    colDefs.push({
                        accessor: field.ACCESSOR,
                        Header: (e: any) => <div className="cell-text-non-sortable">{field.DISPLAY}</div>,
                        headerClass: field.MANDATORY ? "" : "greenTableHeader",
                        Cell: (e: any) => {
                            if (field.ACCESSOR === 'errors' && typeof e.value === 'object' && e.value !== null) {
                                return <div className="cell-text">{JSON.stringify(e.value)}</div>;
                            }
                            return <div className="cell-text">{e.value}</div>;
                        }
                    });
                }
            });
            Object.values(CONSTANTS.ADDITIONAL_REVIEW_JE_FIELDS).forEach(x => {
                colDefs.push({
                    accessor: x.ACCESSOR,
                    Header: (e: any) => <div className="cell-text-non-sortable">{x.DISPLAY}</div>,
                    Cell: (e: any) => <div className="cell-text">{e.value}</div>
                });
            });
        return colDefs;
    }


    const columnDefinitions = React.useMemo(getColumnDefinitions, [data]);

    return (
        <div className="reviewJournalTableContainer">
            <TPEReactTable {...{
                data,
                columnDefinitions,
                className: "nonGridTable journalEntries",
                sortable: false,
                isSearching: journalsLinesLoading,
                isSearchingMessage: "Loading review journal lines...",
            }} />
        </div>
    );
}